
const SelectionIndicator = (props: { currentIndex: number, selectedIndex: null | number }) => {
  return (
    <span style={{ display: props.currentIndex === props.selectedIndex ? 'block' : 'none' }} className="selection-indicator circle" title="There is an item selected from this category">

    </span>
  )
}

export default SelectionIndicator